import lists from "./lists"
import pages from "./pages"
import timelines from "./timelines"
import ui from "./ui"
import uploads from "./uploads"
import user from "./user"

export default [...lists, ...pages, ...timelines, ...ui, ...uploads, ...user]
